import { generatePath } from 'react-router-dom'

class RouteError extends Error {
    constructor(msg) {
        super('RouteError: ' + msg)
    }
}

export const routeConfig = [
    {
        path: '/logout',
        title: 'Logout',
        component: './Logout',
        name: 'logout',
        breadcrumbs: [{ label: 'Logout' }],
    },
    {
        path: '/products/skus',
        title: 'Products',
        component: './Product/ProductSkuList',
        name: 'products-skus',
    },
    {
        path: '/products/portfolios',
        title: 'Products',
        component: './Product/ProductPortfolioList',
        name: 'products-portfolios',
    },
    {
        path: '/products/solutions',
        title: 'Products',
        component: './Product/ProductSolutionsList',
        name: 'products-solutions',
    },
    {
        path: '/products/overview',
        title: 'Products',
        component: './Product/ProductOverviewList',
        name: 'products-overview',
    },
    {
        path: '/contracts/overview',
        title: 'Contracts',
        component: './Contract/ContractOverviewList',
        name: 'contracts-overview',
    },
    {
        path: '/costs/overview',
        title: 'Costs',
        component: './Cost/CostOverviewList',
        name: 'costs-overview',
    },
    {
        path: '/',
        title: 'Homepage',
        component: './Home',
        name: 'home',
    },
]

export const reverse = (name, params = {}, queryParams = {}) => {
    const routes = routeConfig.filter(route => route.name === name)
    if (routes.length === 0) {
        throw new RouteError(`No matches found in routeConfig for ${name}`)
    } else if (routes.length > 1) {
        throw new RouteError(
            `Multiple matches found in routeConfig for ${name}: ${routes
                .map(r => r.path)
                .join(', ')}`
        )
    }
    // this will raise a TypeError if params provided do not match the path
    const path = generatePath(routes[0].path, params)
    if (Object.entries(queryParams).length) {
        const searchParams = new URLSearchParams(queryParams)
        return `${path}?${searchParams.toString()}`
    }
    return path
}
